import AlternativeSearchResults from './AlternativeSearchResults';

export default AlternativeSearchResults;
